<div class="ACVTY-chmp-wrp">
  <button (click)="closeDialog()" class="ACVTY-closebtn-chmp">
    <img
      src="assets/img/my-activity/ACVTY-cross-white.svg"
      class="ACVTY-closebtn-sicon"
    />
  </button>
  <img src="{{ badthImg }}" alt="" class="ACVTY-chmp-iconimg" />
  <div class="ACVTY-ovflw-cont">
    <h3 class="ACVTY-chmp-title">{{ batchName }}</h3>
    <p class="ACVTY-chmp-subtxt" *ngIf="perc == 100">{{rewardDescription}}</p>
    <p class="ACVTY-chmp-subtxt" *ngIf="perc != 100">{{ description }}</p>
    <div class="ACVTY-chmp-sharetxtbox" *ngIf="perc == 100">
      <div class="ACVTY-chmp-share"><p class="ACVTY-chmp-sharetxt" *ngIf="perc == 100">Share with friends</p></div>
      <div class="ACVTY-socialicon-wrp" *ngIf="perc == 100">
        <button
          class="socalMedia"
          [url]="referralObj?.deepLink"
          shareButton="whatsapp"
          (click)="sendModeOfShare('whatsapp')"
        >
          <img
            src="assets/img/my-activity/ACVTY-share-watsapp.svg"
            alt=""
            class="ACVTY-socialicon-s"
          />
        </button>
        <button
          class="socalMedia"
          [href]="referralObj?.deepLink"
          shareButton="facebook"
          (click)="sendModeOfShare('facebook')"
        >
          <img
            src="assets/img/my-activity/ACVTY-share-facebook.svg"
            alt=""
            class="ACVTY-socialicon-s"
          />
        </button>
        <!-- <button class="socalMedia"  shareButton="linkedin" [[href]="referralObj?.deepLink"
                (click)="sendModeOfShare('linkedin')">
                <div class="REF-sh-icon-outer">
                    <i class="fab fa-linkedin-in REF-sh-linkedin-ic"></i>
                </div>
            </button> -->
        <button class="socalMedia" (click)="copyRefCode()">
          <img
            src="assets/img/my-activity/copy.svg"
            alt=""
            class="REF-copyimg-btn"
          />
        </button>
      </div>
    </div>
    <button
      class="btn allBadges"
      *ngIf="perc == 100"
      (click)="navigateAllBadges()"
    >
      SEE ALL BADGES
    </button>
  </div>
  <button class="ACVTY-got-btn" *ngIf="perc != 100" (click)="closeDialog()">
    GOT it
  </button>
</div>
